import { alpha } from '@mui/material/styles';
import { JLR_PLANT } from '../../constants';

export default function Popover(theme) {
  const isJlr = theme.plantName === JLR_PLANT;
  const isDarkMode = theme.palette.mode === 'dark';

  const jlrPopoverStyles = {
    paper: {
      backgroundImage: 'none',
      background: isDarkMode 
        ? 'linear-gradient(135deg, #1a1d20, #2d3136)'
        : 'linear-gradient(135deg, #ffffff, #fafbfc)',
      borderRadius: '16px',
      border: `1px solid ${isDarkMode 
        ? 'rgba(255, 255, 255, 0.1)' 
        : 'rgba(45, 74, 45, 0.1)'}`,
      boxShadow: isDarkMode 
        ? '0 16px 40px rgba(0, 0, 0, 0.3), 0 4px 16px rgba(0, 0, 0, 0.2)'
        : '0 16px 40px rgba(45, 74, 45, 0.12), 0 4px 16px rgba(45, 74, 45, 0.08)',
      backdropFilter: 'blur(12px)',
      overflow: 'hidden',
      
      // Elegant top border accent
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '2px',
        background: isDarkMode 
          ? 'linear-gradient(90deg, #0066cc, #c8b99c)'
          : 'linear-gradient(90deg, #2d4a2d, #c8b99c)',
        borderRadius: '16px 16px 0 0',
      },
    },
  };

  const standardPopoverStyles = {
    paper: {
      backgroundImage: 'none',
      borderRadius: '8px',
      boxShadow: theme.shadows[8],
    },
  };

  const styles = isJlr ? jlrPopoverStyles : standardPopoverStyles;

  return {
    MuiPopover: {
      styleOverrides: {
        paper: styles.paper,
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          ...styles.paper,
          minWidth: isJlr ? '200px' : '160px',
        },
        list: {
          padding: isJlr ? '8px' : '4px',
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: isJlr ? "'Inter', sans-serif" : theme.typography.fontFamily,
          fontSize: isJlr ? '0.875rem' : '0.8125rem',
          fontWeight: isJlr ? 500 : 400,
          padding: isJlr ? '12px 16px' : '8px 12px',
          borderRadius: isJlr ? '8px' : '4px',
          margin: isJlr ? '2px 0' : '1px 0',
          color: isJlr ? (isDarkMode ? '#ffffff' : '#2d4a2d') : theme.palette.text.primary,
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          
          '&:hover': {
            background: isJlr 
              ? (isDarkMode 
                ? 'rgba(0, 102, 204, 0.1)' 
                : 'rgba(45, 74, 45, 0.08)')
              : alpha(theme.palette.primary.main, 0.04),
            transform: isJlr ? 'translateX(4px)' : 'none',
          },

          '&.Mui-selected': {
            background: isJlr 
              ? (isDarkMode 
                ? 'rgba(0, 102, 204, 0.2)' 
                : 'rgba(45, 74, 45, 0.12)')
              : alpha(theme.palette.primary.main, 0.08),
            
            '&:hover': {
              background: isJlr 
                ? (isDarkMode 
                  ? 'rgba(0, 102, 204, 0.3)' 
                  : 'rgba(45, 74, 45, 0.16)')
                : alpha(theme.palette.primary.main, 0.12),
            },
          },

          '&.Mui-disabled': {
            opacity: 0.5,
            color: isJlr ? (isDarkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(45, 74, 45, 0.5)') : theme.palette.text.disabled,
          },
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: isJlr ? "'Inter', sans-serif" : theme.typography.fontFamily,
          fontSize: isJlr ? '0.75rem' : '0.6875rem',
          fontWeight: isJlr ? 500 : 400,
          background: isJlr 
            ? (isDarkMode 
              ? 'rgba(26, 29, 32, 0.95)' 
              : 'rgba(45, 74, 45, 0.95)')
            : theme.palette.grey[700],
          color: '#ffffff',
          borderRadius: isJlr ? '8px' : '4px',
          padding: isJlr ? '8px 12px' : '6px 8px',
          boxShadow: isJlr 
            ? '0 8px 24px rgba(0, 0, 0, 0.2)'
            : theme.shadows[1],
          backdropFilter: isJlr ? 'blur(8px)' : 'none',
        },
        arrow: {
          color: isJlr 
            ? (isDarkMode 
              ? 'rgba(26, 29, 32, 0.95)' 
              : 'rgba(45, 74, 45, 0.95)')
            : theme.palette.grey[700],
        },
      },
    },
  };
}
